import React from 'react';
import cx from 'classnames';
import Icon, { IconSize } from './Icon';
import styles from './muiIcons.module.scss';
import chevronDownIcon from '../../../assets/icons/chevron-down.svg';
import closeIcon from '../../../assets/icons/close.svg';
import calendarIcon from '../../../assets/icons/calendar.svg';
import circleInfoIcon from '../../../assets/icons/circle-info.svg';
import circleCheckIcon from '../../../assets/icons/circle-check.svg';
import circleAlertIcon from '../../../assets/icons/circle-alert.svg';
import triangleAlertIcon from '../../../assets/icons/triangle-alert.svg';

// MUI draws these in place of its Material icons (theme.ts, DateInput), so
// a select arrow, a date picker or an alert comes from the same set as the
// rest of the site (design audit, section 4.6). MUI hands its slots SvgIcon
// props (fontSize, ownerState...) that mean nothing to an inline svg; only
// the class name is forwarded, because it carries MUI's positioning and the
// open-state rotation of the select / autocomplete arrow.
type SlotProps = {
  className?: string;
};

export const ChevronDownIcon = ({ className }: SlotProps) => (
  <Icon src={chevronDownIcon} className={className} />
);

// The calendar's month arrows: the same chevron turned, so the set needs
// no left / right copy of it.
export const ChevronLeftIcon = ({ className }: SlotProps) => (
  <Icon src={chevronDownIcon} className={cx(styles.left, className)} />
);

export const ChevronRightIcon = ({ className }: SlotProps) => (
  <Icon src={chevronDownIcon} className={cx(styles.right, className)} />
);

export const ClearIcon = ({ className }: SlotProps) => (
  <Icon src={closeIcon} size={IconSize.s} className={className} />
);

export const CalendarIcon = ({ className }: SlotProps) => (
  <Icon src={calendarIcon} className={className} />
);

// Ready elements for the theme's defaultProps (theme.ts is not a tsx file)
export const autocompletePopupIcon = <ChevronDownIcon />;
export const autocompleteClearIcon = <ClearIcon />;

export const alertIconMapping = {
  error: <Icon src={circleAlertIcon} />,
  warning: <Icon src={triangleAlertIcon} />,
  success: <Icon src={circleCheckIcon} />,
  info: <Icon src={circleInfoIcon} />,
};
